import { FC } from 'react';

export interface SvgTranscriptLinesProps {
  size?: number;
}

export const SvgTranscriptLines: FC<SvgTranscriptLinesProps> = ({ size = 14 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.75}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M4 6h12" />
    <path d="M4 11h16" />
    <path d="M4 16h10" />
    <path d="M4 21h14" />
  </svg>
);
